module.exports = __webpack_public_path__ + "static/media/exit_dictation.4db6c2a4.mp3";